import { interfaces } from '@daas-consulting/core-cross-interfaces';

export function getRawValueZeroOrUndefined(
  array: interfaces.Criteria[]
): unknown | undefined {
  let rv = undefined;
  if (Array.isArray(array) && array.length) {
    rv = array[0].rawValue;
  }

  return rv;
}
